async function add_skill(sender) {
    const $ = jQuery.noConflict();

    const name = sender.prev().val().trim();
    if (name === 'Maak een keuze') {
        return;
    }

    return await $.post('/course/skills/create', { name });
}
